package com.macrofocus.trenddisplay

import com.macrofocus.common.properties.EnumProperties
import com.macrofocus.common.properties.MutableProperties
import com.macrofocus.common.properties.MutableProperty
import com.macrofocus.trenddisplay.timeseriesplot.TimeSeriesPlotView
import org.mkui.canvas.Rendering
import org.molap.series.TimeSeries

class TrendDisplaySettings<Column> {
    enum class PropertyType {
        Time,
        Id,
        Style,
        Layout,
        Mode,
        Rendering
    }

    var properties: MutableProperties<PropertyType>
        protected set

    init {
        properties = EnumProperties<PropertyType>(PropertyType.values())

        properties.createProperty(PropertyType.Time, null as Column?)
        properties.createProperty(PropertyType.Id, null as Column?)
        properties.createProperty(PropertyType.Style, TimeSeriesPlotView.Style.Straight)
        properties.createProperty(PropertyType.Layout, TimeSeriesPlotView.Layout.Overlay)
        properties.createProperty<Any>(PropertyType.Mode, TimeSeries.TimeMode.Absolute)
        properties.createProperty<Any>(PropertyType.Rendering, Rendering.AlphaBlended)
    }

    val time: MutableProperty<Column?>
        get() = properties.getProperty(PropertyType.Time) as MutableProperty<Column?>

    val id: MutableProperty<Column?>
        get() = properties.getProperty(PropertyType.Id) as MutableProperty<Column?>

    val rendering: MutableProperty<Any?>
        get() = properties.getProperty(PropertyType.Rendering)

    val style: MutableProperty<TimeSeriesPlotView.Style?>
        get() = properties.getProperty(PropertyType.Style) as MutableProperty<TimeSeriesPlotView.Style?>

    val mode: MutableProperty<TimeSeriesPlotView.Style?>
        get() = properties.getProperty(PropertyType.Mode) as MutableProperty<TimeSeriesPlotView.Style?>

    val layout: MutableProperty<TimeSeriesPlotView.Layout?>
        get() = properties.getProperty(PropertyType.Layout) as MutableProperty<TimeSeriesPlotView.Layout?>
}
